<template>
    <div class="ws-page">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Academic Management</span>
        </base-header>

        <div class="container-fluid mt--7 ws-page__body">
            <section class="ws-panel" aria-labelledby="academic-management-title">
                <header class="ws-panel__intro">
                    <div class="ws-panel__text">
                        <span class="ws-eyebrow">SCHOOL SETUP</span>
                        <h1 id="academic-management-title">Academic management</h1>
                        <p>
                            Set up the school calendar, classes, subjects and the assessment
                            structure used across reports and results.
                        </p>
                    </div>
                    <div class="ws-panel__side">
                        <div class="ws-stat">
                            <strong>{{ tools.length }}</strong>
                            <span>setup tools</span>
                        </div>
                    </div>
                </header>

                <SubMenu />
            </section>
        </div>
    </div>
</template>

<script>
import SubMenu from "./SubMenu.vue";
import tools from "./tools";

export default {
    name: "AcademicManagement",
    components: {
        SubMenu
    },
    data() {
        return {
            accessDetails: null,
            tools
        };
    },
    mounted() {
        this.accessDetails = this.$store.getters["auth/_user"];
        if (!this.accessDetails || this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    }
};
</script>
